import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {Box, Grid, Button} from '@material-ui/core';
import {OutlinedInput, FormControl, Stack, Snackbar, Alert, LinearProgress, Radio, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import {MetaTags} from 'react-meta-tags';
import { LoadingButton } from '@mui/lab';
import axios from 'axios';
import Cookies from 'js-cookie';
import Tooltip from '@mui/material/Tooltip';
import Authorization from '../components/Authorization'; 
import FreeCompanySave from './FreeCompanySave';
import { useSelector } from 'react-redux';
import {API_URL} from '../utils/EnvVars';
import Header from "../common/HeaderMy";
///import moment from 'moment';
import '../styles/bizofficer-a.css';
import 'font-awesome/css/font-awesome.min.css';
import { json } from 'react-router-dom';

  
  var vertical='top',horizontal='center';
  
  export default function Execute() {
	const userObj = useSelector(state => state.userDetails);
	const isloggedin = Cookies.get('isrwadminloggedin');
	const childRefSave = React.useRef();
	const childRefAuthorization = React.useRef();
	const [privileges, setPrivileges] = React.useState("");
	const [dataLoading, setDataLoading] = React.useState(true);
	const [deleteDialogShow, setDeleteDialogShow] = React.useState(false); 
	const [filter, setFilter] = React.useState(false);
	const [searchBtnLoading, setSearchBtnLoading] = React.useState(false);
	const [keyword, setKeyword] = React.useState("");
	const [dataObj, setDataObj] = React.useState({});
	const [rows, setRows] = React.useState([]);
	const [selectedRow, setSelectedRow] = React.useState(0);
	const [page, setPage] = React.useState(0);
	const [rowCount, setRowCount] = React.useState(0);
	const pageSize = 100;
	const [paginationModel, setPaginationModel] = React.useState({
		page: 0,
		pageSize: 100,
	  });

	const [severityAlert, setSeverityAlert] = React.useState("error");
	const [showAlert, setShowAlert] = React.useState(false);
	const [alertMessage, setAlertMessage] = React.useState("");
	const [filterBy, setFilterBy] = React.useState(0);

	const authResult = new URLSearchParams(window.location.search); 
	const fullList = authResult.get('fullList');

	var myCurrentDate=new Date();
	var myPastFromDate=new Date(myCurrentDate);
    myPastFromDate.setDate(myPastFromDate.getDate() - 366);

	function hideAlert(){
		setShowAlert(false);
	}

	const columns = [
		{
			field: "Select",
			headerName: "",
			width: 60,
			sortable: false,
				renderCell: (cellValues) => {
				return (
				  <Radio 
					checked={cellValues.id === selectedRow}
					value={cellValues.id}
					name="radio-buttons"
					inputProps={{ 'aria-label': {cellValues} }}
				  />
				 )
			  }
		  },
		{ field: 'srno', headerName: 'Sr. No.', width: 40 },
		{ field: 'autoId', headerName: 'Auto ID', width: 80 },
		{ field: 'companyName', headerName: 'Company Name', width: 200, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), }, 
		{ field: 'address', headerName: 'Address', width: 200, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'city', headerName: 'City', width: 80, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'state', headerName: 'State', width: 80, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'country', headerName: 'Country', width: 80, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
		{ field: 'pincode', headerName: 'Pincode', width: 80, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },  
	    { field: 'mobile', headerName: 'Mobile', width: 80, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
	    { field: 'addedByName', headerName: 'Added By', width: 80, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },   
	    { field: 'modifiedDateTime', headerName: 'Modified Time', width: 130, renderCell: (params) =>  (
			<span>{params.value}</span>
		   ), }, 
		{ field: 'prdCount', headerName: 'Prd. Count', width: 80 },
		   
	  ];
	

	// check if logged in
	React.useEffect(() => {
		if(!isloggedin){
			window.location.href='login';
		}
	}, [isloggedin]);

	React.useEffect(() => {		
		if(userObj.loginId && userObj.fullName && userObj.token){
			getApiData(userObj.loginId,userObj.fullName,userObj.token);
		}
	}, [userObj,filter]);

	async function getApiData(uid,fullName,token){
		  let qs='&byuser=1';
		  if(fullList && fullList==1){
			qs='&byuser=0';
		  }		  
		  if(filterBy>0){
			qs+='&option='+filterBy;
		  }
		  let apiUrl=API_URL+'/list-company-free?minRows='+(page*pageSize)+'&maxRows='+pageSize+'&keyword='+keyword+qs;
		  let axiosHeader = {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'uid': uid,
					'fullName': fullName,
					'token': token,
			};
			const config = {
				method: 'get',
				url: apiUrl,
				headers: axiosHeader
			}
			setDataLoading(true);
			await axios(config)
			   .then(response => {
				setDataLoading(false);
				setSearchBtnLoading(false);
				if(response && response.data && response.data.responseTxt==="success"){
					 if(page===0){
						setRowCount(response.data.rowCount);
					 }  
				 	 setRows(response.data.obj);	
					 setPrivileges(response.data.privileges);			 				
				}else if(response && response.data && response.data.responseTxt==="invalidtoken"){
					window.location.href='invalidtoken';
				}else if(response && response.data && response.data.responseTxt==="NoAuthorization"){
					childRefAuthorization.current.handleClickOpen();
				}
			}).catch((error) => {
				setSeverityAlert("error");
				setShowAlert(true);
				setAlertMessage(" "+error);			
				return false;
			})
	}

	function deleteData(){
		if(dataObj && dataObj!=null && userObj){
			let apiUrl=API_URL+'/admin-delete-temp-company';
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'uid': userObj.loginId,
					'fullName': userObj.fullName,
					'token': userObj.token,
				}
			};
  
		  const data = new FormData();
		  data.append('id', dataObj.autoId);				 
		  axios.post(apiUrl, data, axiosHeader)
				.then((response) => {
					///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
					setSeverityAlert("success");
					///setOpen(false);
					setShowAlert(true);
					setAlertMessage("Keyword name has been deleted.");
			  		window.location.reload();	
					return false;
				}else{
			  		setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Keyword name could not be deleted.");			
					return false;
				}
			})
			.catch((error) => {
				setSeverityAlert("error");
				setShowAlert(true);
				setAlertMessage(" "+error);			
				return false;
			})	
		}		
	
		
	}

	function saveData(opt){
		if(opt===1){
			setDataObj(null);
			childRefSave.current.handleClickOpen();
		}else if(opt===2){
			childRefSave.current.handleClickOpen();
		}	
		
	}
	
	function selectRow(obj){
		if(obj && rows[obj.id-1]){			
			setSelectedRow(rows[obj.id-1].id);
			setDataObj(rows[obj.id-1]);
			///childRef.current.handleClickOpen();
		}
	}

	const handleOnCellClick = (obj) => {
		if(obj.field==='companyName'){
			setSelectedRow(rows[obj.id-1].id);
			setDataObj(rows[obj.id-1]);
			if(dataObj && dataObj.initialUrl){
				window.location="free-products?initialUrl="+dataObj.initialUrl;
			}
		}		
	};

	function search(){
		setSearchBtnLoading(true);
		setPage(0);
		setSelectedRow(0);
		setDataObj({});
		setFilter(!filter);
	} 

	function onEnter(event){
		if(event.key === 'Enter'){
			search();
		}
	}
	
	function deleteDialogHide(){
		setDeleteDialogShow(false);
	}

	function handlePaginationModel(obj){
		///alert(JSON.stringify(obj));
		setPage(obj.page);
		setPaginationModel(obj);
		setSelectedRow(0);
		setDataObj({});
		setFilter(!filter);
	}

	function handleKeyword(txt){
		setPage(0);
		setSelectedRow(0);
		setDataObj({});
		setKeyword(txt);
	}


	return (
		<div> 
				<MetaTags>
            		<title>Company List</title>
          		</MetaTags>
				
				<Header hamburger={true} pageTitle="Company List" />
				{dataLoading?<LinearProgress />:null}

				<Box className='mainBox'>	

				<Box mt={1} mb={1} >
							<Grid container spacing={2}>
								<Grid item md={12} xs={12} >

									<FormControl style={{width:170,marginRight:6,float:'left'}} fullWidth size="small">
										<InputLabel id="country-select-small-label">Filter</InputLabel>
										<Select
										labelId="country-select-small-label"
										id="country-select-small"
										value={filterBy}
										label="Filter"
										onChange={event => setFilterBy(event.target.value)}
										>
											<MenuItem value={0} >All</MenuItem>
											<MenuItem value={1} >Product Added</MenuItem>
											<MenuItem value={2} >Product Not Added</MenuItem>
										</Select>
									</FormControl>

									<FormControl style={{width:150,marginRight:60,float:'left'}}  >
										<OutlinedInput 
										 id="keywordtxt"
										 placeholder="Search"
										 value={keyword}
										 onChange={event => handleKeyword(event.target.value)}
										 onKeyPress={(event)=>{onEnter(event)}}
										 style={{width:200,height:40}}
										 size="small"
										 />
									</FormControl>

									{searchBtnLoading?
                        			  <LoadingButton loading={true} loadingPosition='start' startIcon={<div style={{marginRight:15}} ></div>} style={{marginTop:4,float:'left',backgroundColor:'#FFF',textTransform: 'none'}} size="small" variant="contained"  >Searching...</LoadingButton>
					    	          :
									  <Button onClick={() => {search()}} style={{marginTop:4,float:'left',backgroundColor:'#FFF',textTransform: 'none'}} size="small" variant="contained"  >Search</Button>
									}

									<div style={{float:'left'}}>	
										{(privileges && privileges.indexOf("create")>-1)?<>
											<i onClick={()=>{saveData(1)}} title="Add New" className="fa fa-plus-circle btncolor" style={{fontSize:30, marginLeft:15, cursor:'pointer'}} />
										</>:null}
									{selectedRow>0?<>	
										{(privileges && privileges.indexOf("update")>-1)?<>
											<i onClick={()=>{saveData(2)}} title="Edit" className="fa fa-pencil-square-o btncolor" style={{fontSize:30, marginLeft:15, cursor:'pointer'}} />
										</>:null}
										{/* {(privileges && privileges.indexOf("delete")>-1)?
											<i onClick={()=>{setDeleteDialogShow(true)}} title="Delete" className="fa fa-trash btncolor" style={{fontSize:30, marginLeft:15, cursor:'pointer'}} />
										:null} */}
									</>:null}	

									</div>	
								</Grid>
							</Grid>
					</Box>

					<div className="tblReport" style={{height: '78vh', width: '100%' }}>						
						<DataGrid
							rows={(rows || [])}
							columns={columns}
							pageSize={pageSize}
							rowsPerPageOptions={[pageSize]}
							rowHeight={40}
							rowCount={rowCount}								
							paginationModel={paginationModel}
        					paginationMode="server"
        					onPaginationModelChange={handlePaginationModel}
							loading={dataLoading}
							disableSelectionOnClick															
							style={{fontSize:12}}	
							onRowClick={itm => selectRow(itm)}							
							onCellClick={handleOnCellClick}
							components={{
								NoRowsOverlay: () => (
								  <Stack height="100%" alignItems="center" justifyContent="center">
									<span style={{color:'#FF0000',fontWeight:'bold'}}>No company found!</span>
								  </Stack>
								)}}	
								
						/>
					</div>

				</Box>
				
			<FreeCompanySave dataObj={dataObj} userObj={userObj} ref={childRefSave} />

			<Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
			</Stack>

				<Dialog
					open={deleteDialogShow}
					onClose={deleteDialogHide}
					aria-labelledby="alert-dialog-section-title"
					aria-describedby="alert-dialog-section-description"
				>
					<DialogTitle id="alert-dialog-section-title">
						Alert
					</DialogTitle>
					<DialogContent>
					<DialogContentText style={{width:280}} id="alert-dialog-section-description">
						Are you sure, You want to delete.
					</DialogContentText>
					</DialogContent>
					<DialogActions>
					<Button variant="outlined" size="small" onClick={()=>{deleteDialogHide()}}>Don't Delete</Button>
					<Button variant="contained" size="small" color="secondary" onClick={()=>{deleteData()}} autoFocus>Yes, Delete</Button>
					</DialogActions>
				</Dialog>

				<Authorization ref={childRefAuthorization} />
		</div>	
	);
  }